module.exports = __webpack_public_path__ + "static/media/wowwayModal.0fd5428f.png";